import { render, staticRenderFns } from "./CidadaoEditar.vue?vue&type=template&id=5664937c&"
import script from "./CidadaoEditar.vue?vue&type=script&lang=js&"
export * from "./CidadaoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports